import axios from 'axios'
import $util from '@/utils/utils'
const isNewVersion = (to) => {
  let url;
  if($util.isLocal()) {
    url = `/gt6/version.pt?t=${new Date().getTime()}`
  } else {
    url = $util.getCurrentWebSite()+`/gt6/version.pt?t=${new Date().getTime()}`;
    // url = $util.getCurrentWebSite()+`/resources/file/version.pt?t=${new Date().getTime()}`;
  }
  axios.get(url).then(res => {
    if (res.status === 200) {
      let version = res.data,
      // let version = res.data.version,
      localVersion = sessionStorage.getItem('gt6Version');
      if(!localVersion) {
        sessionStorage.setItem('gt6Version', version);
      }
      if (localVersion && localVersion != version) {
        sessionStorage.setItem('gt6Version', version);
        // if(localStorage.getItem('gt6_user_info')) {
          window.location = $util.getCurrentWebSiteByProduct()+to.fullPath
        // }
      } 
    }
  });
}
 
export default {
  isNewVersion
}